import { TextField } from 'mui-rff';
import React from 'react';

import { MenuItem } from '@mui/material';

type Props = {
  label: string;
  name: string;
  options: { label: string; value: string }[];
};
export default function Select({ label, name, options }: Props) {
  return (
    <TextField select variant="standard" label={label} name={name}>
      {options.map((k, i) => (
        <MenuItem key={i} value={k.value}>
          {k.label}
        </MenuItem>
      ))}
    </TextField>
  );
}
